import { styled } from "@mui/material/styles"
import { Typography } from "@mui/material"

export const StyledLink = styled(Typography)(({ theme, variant }) => ({
  textDecoration: "none",
  color: theme.tokens.color.link,
  "&:hover": {
    textDecoration: "underline",
    color: theme.palette.primary.main,
    cursor: "pointer",
  },
  "&:active": {
    color: theme.palette.primary.main,
    textDecoration: "underline",
  },
  [theme.breakpoints.down("md")]: {
    fontSize:
      variant === "body1" ? "0.8rem" : variant === "body2" ? " 0.5rem" : "1rem",
  },
  [theme.breakpoints.up("md")]: {
    fontSize:
      variant === "body1" ? "1rem" : variant === "body2" ? " 0.875rem" : "1rem",
  },
}))
